import React, { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { pusherContext } from 'services/Pusher'
import { notificationService } from 'services/NotificationService'

const PusherDebug = () => {
  const pusherChannel = useContext(pusherContext)
  const { user } = useSelector((state) => state.auth)
  const [events, setEvents] = useState([])

  useEffect(() => {
    if (!pusherChannel) {
      console.log('🔴 PusherDebug: Canal no disponible')
      return
    }

    console.log('🟢 PusherDebug: Canal disponible:', pusherChannel)
    console.log('👤 Usuario UUID:', user?.uuid)
    console.log('🔌 NotificationService conectado:', notificationService.isConnected())

    // Listener genérico para TODOS los eventos
    const allEventsHandler = (eventName, data) => {
      console.log(`📡 Evento recibido: ${eventName}`, data)
      setEvents(prev => [...prev, { eventName, data, time: new Date().toLocaleTimeString() }])
    }

    // Bind a todos los eventos conocidos
    const eventNames = [
      '.ticket-created',
      '.ticket-new-message',
      '.ticket-change-status',
      '.ticket-expired',
      '.ticket-assigned'
    ]

    eventNames.forEach(eventName => {
      pusherChannel.listen(eventName, (data) => {
        console.log(`✅ ${eventName} recibido:`, data)
        allEventsHandler(eventName, data)
      })
    })

    // Test de conexión
    console.log('🧪 Pusher Debug: Listeners configurados para:', eventNames)

  }, [pusherChannel, user?.uuid])

  if (!pusherChannel) {
    return (
      <div style={{
        position: 'fixed',
        bottom: '190px',
        left: '20px',
        padding: '10px',
        background: 'red',
        color: 'white',
        borderRadius: '8px',
        fontSize: '12px',
        zIndex: 9999
      }}>
        🔴 Pusher NO conectado
      </div>
    )
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '390px',
      left: '20px',
      padding: '10px',
      background: '#1f2937',
      color: 'white',
      borderRadius: '8px',
      fontSize: '12px',
      maxWidth: '300px',
      maxHeight: '400px',
      overflow: 'auto',
      zIndex: 9999
    }}>
      <div style={{ marginBottom: '10px', fontWeight: 'bold' }}>
        🟢 Pusher Debug
      </div>
      <div style={{ fontSize: '10px', marginBottom: '5px' }}>
        UUID: {user?.uuid || 'N/A'}
      </div>
      <div style={{ fontSize: '10px', marginBottom: '10px' }}>
        Conectado: {notificationService.isConnected() ? '✅' : '❌'}
      </div>
      <div style={{ borderTop: '1px solid #374151', paddingTop: '10px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
          Eventos ({events.length}):
        </div>
        {events.length === 0 ? (
          <div style={{ fontSize: '10px', color: '#9ca3af' }}>
            Esperando eventos...
          </div>
        ) : (
          events.slice(-5).reverse().map((event, i) => (
            <div key={i} style={{
              fontSize: '10px',
              marginBottom: '5px',
              padding: '5px',
              background: '#374151',
              borderRadius: '4px'
            }}>
              <div style={{ color: '#60a5fa' }}>{event.eventName}</div>
              <div style={{ color: '#9ca3af' }}>{event.time}</div>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default PusherDebug
